module.exports = __webpack_public_path__ + "zip/digthread8x11.zip";